import React from 'react';
import PropTypes from 'prop-types';

import Video from '../Video';
import defaultOfferingImage from '../../assets/images/default-offering-image.png';

const VideoOrImage = ({ asset, ...props }) => {
  const {
    url,
    previewImageUrl,
    title = '',
    type = '',
  } = asset || {};
  if (type.startsWith('video/') || type.startsWith('vimeo')) {
    return (
      <Video
        videoUrl={url}
        imageUrl={previewImageUrl || defaultOfferingImage}
        {...props}
      />
    );
  }
  return (
    <img
      style={{ maxWidth: '100%' }}
      src={url || defaultOfferingImage}
      alt={title}
      {...props}
    />
  );
};

VideoOrImage.propTypes = {
  playBtnSize: PropTypes.oneOf(['small', 'medium', 'large']),
  asset: PropTypes.shape({
    url: PropTypes.string.isRequired,
    previewImageUrl: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
};

VideoOrImage.defaultProps = {
  playBtnSize: 'large',
};


export default VideoOrImage;



// WEBPACK FOOTER //
// ./src/components/VideoOrImage/index.js